import React from 'react';
import { Dropdown } from 'freemium-ui';
import { useController, useFormContext } from 'react-hook-form';

import Icons from 'components/icons';

import { ACTIVE_OPTIONS as OPTIONS, NEXT_OPTIONS } from '../../../../constants';
import { setBlockQuestions } from './utils';
import { getDefaultQuestion } from '../../add-new-block';

export type BlockConfigProps = {
  thankYouMessage: Boolean | undefined;
  block: any;
  setSurveyForm: any;
  blockQuestionIndex: any;
  disabled?: any;
};

export const BlockConfig = ({
  thankYouMessage,
  block,
  disabled,
  setSurveyForm,
  blockQuestionIndex,
}: BlockConfigProps) => {
  const { control, getValues } = useFormContext();
  const surveyForm = getValues();

  return (
    <div className="section-configuration">
      <div className="form-field">
        <label htmlFor="type">Type</label>
        <div className="option">
          {!thankYouMessage ? (
            <BlockType
              defaultValue={
                surveyForm.question_details?.questions?.[blockQuestionIndex]
                  ?.type_info
              }
              block={block}
              questions={surveyForm.question_details.questions}
              disabled={
                disabled ||
                surveyForm.question_details?.questions?.[blockQuestionIndex]?.id
              }
              control={control}
              blockQuestionIndex={blockQuestionIndex}
            />
          ) : (
            <Dropdown
              defaultSelectedItem={{
                id: 'ty',
                label: 'Thank you message',
              }}
              disabled
              itemToString={(item: any) => item.label}
              items={[{ id: 'ty', label: 'Thank you message' }]}
            />
          )}
        </div>
      </div>
      <div className="form-field">
        <label htmlFor="type">Show this question</label>
        <div className="option">
          <BlockRatingBased
            defaultValue={
              surveyForm?.question_details?.questions?.[blockQuestionIndex]
                ?.type_info?.meta?.block?.is_based_on_rating
            }
            disabled={disabled}
            block={block}
            surveyForm={surveyForm}
            setSurveyForm={setSurveyForm}
            control={control}
            blockQuestionIndex={blockQuestionIndex}
          />
        </div>
      </div>
    </div>
  );
};

export default BlockConfig;

const BlockRatingBased = ({
  surveyForm,
  setSurveyForm,
  defaultValue,
  control,
  disabled,
  block,
  blockQuestionIndex,
}: any) => {
  const { setValue, watch } = useFormContext();
  const { field } = useController({
    name: `question_details.questions[${blockQuestionIndex}].type_info.meta.block.is_based_on_rating`,
    control,
    defaultValue,
  });

  const value = watch(
    `question_details.questions[${blockQuestionIndex}].type_info.meta.block.is_based_on_rating`,
  );

  return (
    <Dropdown
      defaultSelectedItem={value ? NEXT_OPTIONS[0] : NEXT_OPTIONS[1]}
      itemToString={(item: any) => item.label}
      items={NEXT_OPTIONS}
      onChange={(item: any) => {
        const v = setBlockQuestions(
          watch('question_details.questions'),
          item,
          block,
          blockQuestionIndex,
        );
        setValue('question_details.questions', v);
      }}
      disabled={disabled}
      placeholder="Select question type"
    />
  );
};

const BlockType = ({
  disabled,
  defaultValue,
  control,
  questions,
  block,
  blockQuestionIndex,
}: any) => {
  const { watch } = useFormContext();
  const { field: questionsField } = useController({
    name: `question_details.questions`,
    control,
    defaultValue,
  });

  return (
    <>
      <Dropdown
        defaultSelectedItem={OPTIONS.find(
          (option: any) =>
            option.id ===
            watch(
              `question_details.questions[${blockQuestionIndex}].type_info.question_type`,
            ),
        )}
        disabled={disabled}
        itemToString={(item: any) => (
          <div className="flex">
            <Icons
              size="18"
              viewBox={item?.viewBox || '0 0 18 18'}
              fill="none"
              glyph={item?.icon}
            />
            &nbsp;
            {item.label}
          </div>
        )}
        items={OPTIONS}
        itemComponent={(option: any) => (
          <div className="step-option">
            <Icons
              size="18"
              viewBox={option?.viewBox || '0 0 18 18'}
              fill="none"
              glyph={option?.icon}
            />
            {option.label}
          </div>
        )}
        onChange={(item: any) => {
          const typeInfo = getDefaultQuestion(item.id);
          const blockQuestions = questionsField.value[blockQuestionIndex]
            .type_info.meta.block.question_names || [
            watch(`question_details.questions[${blockQuestionIndex}].name`),
          ];
          const updatedQuestions = questionsField.value.map((question: any) =>
            blockQuestions?.indexOf(question?.name) > -1
              ? {
                  ...question,
                  type_info: {
                    ...question?.type_info,
                    ...typeInfo,
                    // question_type: item.id,
                    ...(item.id === 'DROPDOWN' || item.id === 'MULTI_SELECT'
                      ? {
                          driver: !questions.find(
                            (q: any) =>
                              block.question_names.indexOf(q.name) === -1 &&
                              q.type_info.driver,
                          ),
                          comment: false,
                        }
                      : item.id === 'PARAGRAPH'
                      ? {
                          comment: !questions.find(
                            (q: any) =>
                              block.question_names.indexOf(q.name) === -1 &&
                              q.type_info.comment,
                          ),
                          driver: false,
                        }
                      : {}),
                  },
                }
              : question,
          );
          questionsField.onChange(updatedQuestions);
        }}
        placeholder="Select question type"
      />
    </>
  );
};
